import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimpleCardComponent } from './simple-card.component';

@NgModule({
  declarations: [SimpleCardComponent],
  imports: [CommonModule],
  exports: [SimpleCardComponent],
})
export class SimpleCardModule {}
